module.exports = __webpack_public_path__ + "static/media/servers.fd5e8519.png";